import { z } from "zod";

import { ProjectData } from "../../../../models/ProjectData";
import { zodNullableNumberPipe } from "../../../../utils/zodNullableNumberPipe";

export const schema = z.object({
  project_name: z.string().min(1),
  target_facility_count: zodNullableNumberPipe(z.number().int().gte(0)),
  project_start_date: z.date(),
  onboarding_link: z.string().optional(),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (data: ProjectData): Schema => {
  return {
    project_name: data.name,
    target_facility_count: data.target_facility_count?.toString() ?? undefined,
    project_start_date: data.project_start_date
      ? new Date(data.project_start_date)
      : new Date(),
    onboarding_link: data.onboarding_link ?? "",
  };
};
